
function chunk(array, length) {
  return new Array(Math.ceil(array.length / length)).fill(0)
    .map((_, n) => array.slice(n * length, (n * length) + length));
}

const ranges = [
  [
    [0x1F600, 0x1F637],
    [0x1F641, 0x1F644],
    [0x1F910, 0x1F917],
    [0x1F648, 0x1F64A],
  ],
].map((range) => {
  const chars = ['{emoji}'];
  range.forEach(([start, end]) => {
    for (let c = start; c <= end; c++) {
      chars.push(String.fromCodePoint(c));
    }
  });
  return chunk(chars, 13).map(line => line.join(' '));
});

export default {
  meta: {
    tab: {
      key: '\t',
      text: 'Tab',
      width: 60,
      classes: 'control',
    },
    shiftl: {
      keySet: 'shifted',
      text: '🔼',
      icon: '/images/shift.svg',
      width: 60,
      classes: 'control',
    },
    shiftr: {
      keySet: 'shifted',
      text: '🔼',
      icon: '/images/shift.svg',
      width: 100,
      classes: 'control',
    },
    caps: {
      keySet: 'capsed',
      text: '⏫',
      icon: '/images/caps.svg',
      width: 80,
      classes: 'control',
    },
    emoji: {
      keySet: 'emoji',
      text: '😍',
      classes: 'control',
      width: 40,
    },
    space: {
      key: ' ',
      text: '',
      width: 200,
    },
    enter: {
      key: '\r\n',
      text: '↩',
      width: 80,
      classes: 'control',
    },
    backspace: {
      func: 'backspace',
      text: '⬅',
      icon: '/images/backspace.svg',
      classes: 'control backspace',
      width: 80,
    },
    accept: {
      func: 'accept',
      text: 'Weiter',
      classes: 'control featured',
      width: 60,
    },
    close: {
      func: 'cancel',
      text: 'Schließen',
      classes: 'control featured',
      width: 60,
    },
    next: {
      func: 'next',
      text: 'Next',
      classes: 'control featured',
      width: 40,
    },
  },
  default: [
    { classes: 'num', keyMap: '1 2 3 4 5 6 7 8 9 0' },
    'q w e r t z u i o p ü',
    ' a s d f g h j k l ö ä ',
    '{shiftl} y x c v b n m ß - {backspace}',
    '{close} {space} {accept}',
  ],
  shifted: [
    { classes: 'num', keyMap: '1 2 3 4 5 6 7 8 9 0' },
    'Q W E R T Z U I O P Ü',
    ' A S D F G H J K L Ö Ä ',
    '{shiftl} Y X C V B N M ẞ _ {backspace}',
    '{close} {space} {accept}',
  ],
  capsed: [
    { classes: 'num', keyMap: '1 2 3 4 5 6 7 8 9 0' },
    'Q W E R T Z U I O P Ü ',
    'A S D F G H J K L Ö Ä',
    '{shiftl} Y X C V B N M ẞ _ {backspace}',
    '{emoji} {space} {accept}',
  ],
  emoji: ranges[0],
};
